<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Carousel, Modal, Text } from '@Shelly/shelly-design-system/index';
	import { location, replace } from 'svelte-spa-router';
	import { home_data } from 'src/stores/account/user';
import { is_mobile } from 'src/stores/ui/viewport';
	import { save_home } from 'src/helpers/home_helpers';

	$: showModal =
		(!$home_data?.hasSeenDashOnboarding?.seen ||
			typeof !$home_data?.hasSeenDashOnboarding?.seen === 'undefined') &&
		$location === '/dash';

	let showSetUpLandingContent = false;

	$: carouselSlides = [
		{
			title: $format('qick_access_land_page_title', { default: 'Quick access landing page' }),
			description: $format('qick_access_land_page_desc', {
				default:
					'Your <span class="text-primary">first dashboard</span> becomes your <span class="text-primary">landing page</span> for instant access',
			}),
			gifUrl: $is_mobile
				? './images/dashManagement/newDashMobile.png'
				: './images/dashManagement/newDashDesktop.png',
		},
		{
			title: $format('easy_nav_dash_list_title', { default: 'Easy navigation to dashboard list' }),
			description: $format('easy_nav_dash_list_desc', {
				default:
					'Use the <span class="text-primary">back button in the toolbar</span> to return to your dashboard list',
			}),
			gifUrl: $is_mobile
				? './images/dashManagement/backNavigationMobile.png'
				: './images/dashManagement/backNavigationDesktop.png',
		},
		{
			title: $format('dnd_reordering_title', { default: 'Drag & Drop reordering' }),
			description: $format('dnd_reordering_desc', {
				default:
					'Reorder your dashboards anytime with <span class="text-primary">simple drag and drop</span>',
			}),
			gifUrl: $is_mobile
				? './images/dashManagement/dragAndDropMobile.png'
				: './images/dashManagement/dragAndDropDesktop.png',
		},
		{
			title: $format('set_up_your_land_dash_title', { default: 'Set up your landing dashboard' }),
			description: $format('set_up_land_dash_desc', {
				default:
					'Drag and drop to reorder. The <span class="text-primary">first dashboard</span> will be your <span class="text-primary">landing page</span>.',
			}),
			gifUrl: $is_mobile
				? './images/dashManagement/setUpLandingMobile.svg'
				: './images/dashManagement/setUpLandingDesktop.svg',
		},
	];

	const onClose = () => {
		showModal = false;

		save_home('hasSeenDashOnboarding', {
			seen: true,
		});
	};
</script>

<Modal bind:showModal title="New Dashboard Management" on:close={onClose}>
	<div class="d-flex flex-direction-column" slot="content">
		{#key carouselSlides}
			<Carousel
				contentBorderRadius="--radius-small"
				slides={carouselSlides}
				on:slide-change={(e) => {
					if (e.detail === 3) {
						showSetUpLandingContent = true;
					} else {
						showSetUpLandingContent = false;
					}
				}}
			/>
		{/key}

		{#if showSetUpLandingContent}
			<div class="d-flex flex-direction-column align-items-center width-full mt-l">
				<Button
					on:click={() => {
						onClose();
						replace('/dash?edit=true');
					}}
					class="mb-m width-sm-full width-md-auto"
				>
					{$format('set_up_land_dash_title', { default: 'Set Up Landing Dashboard' })}
				</Button>
				<Text
					style="height: 40px;"
					class="d-flex align-items-center link-styles mb-s"
					on:click={() => {
						onClose();
					}}
				>
					{$format('button_camera_cloud_storage_skip_assignment', { default: 'Skip for now' })}
				</Text>
				<Text class="text-center text-color-muted" styleType="body-extra-small">
					{$format('skip_set_land_dash_descr', {
						default:
							'If you skip setting up your landing dashboard now, we are going to set up your first dash in your dashboard list as landing.',
					})}
				</Text>
			</div>
		{/if}
	</div>
</Modal>
